export default {
  geolocation: {
    lat: '1.3521',
    lng: '103.8198',
    label: '008936 Singapore',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
